import { Vector3 } from 'three'
const v = new Vector3()

export function toVector3(arr?: [number, number] | [number, number, number]) {
  if (!arr) return v.clone().set(0, 0, 0)
  if (arr.length === 3) {
    return v.clone().set(...arr)
  }
  return v.clone().set(arr[0], 10, arr[1])
}
